import { createContext } from 'react';

const useWwwContext = createContext();
export default useWwwContext;
